import React from 'react';
import { UitkTertiaryButton } from 'uitk-react-button';
import { UitkCard } from 'uitk-react-cards';
import { UitkLayoutFlex, UitkLayoutFlexItem } from 'uitk-react-layout-flex';
import { UitkLayoutGrid, UitkLayoutGridItem } from 'uitk-react-layout-grid';
import { UitkSpacing } from 'uitk-react-spacing';
import { UitkText } from 'uitk-react-text';

type Card = {
  heading: string;
  subHeading: string;
  buttons: Button[];
};
type Button = {
  label: string;
  href: string;
};
interface Props {
  title: string;
  cards: Card[];
}
const SolutionCards: React.FC<Props> = ({ cards, title }) => {
  return (
    <UitkLayoutFlexItem className="home-spacing">
      <section id="solutions-section">
        <UitkSpacing margin={{ blockstart: 'four' }}>
          <UitkLayoutFlex direction="column" alignItems="center" className="marketing-page-width">
            <UitkLayoutFlexItem>
              <UitkSpacing margin={{ blockend: 'twelve' }}>
                <UitkText size={700} align="center">
                  {title}
                </UitkText>
              </UitkSpacing>
            </UitkLayoutFlexItem>
            <UitkLayoutFlexItem alignSelf="stretch">
              <UitkLayoutGrid columns={{ small: 1, medium: 2 }} className="cards" space="six">
                {cards.map((card, index) => (
                  <UitkLayoutGridItem key={index}>
                    <UitkCard border padded>
                      <UitkLayoutFlex space="two" direction="column" alignItems="start" justifyContent="space-between">
                        <div>
                          <UitkLayoutFlex direction="column">
                            <UitkSpacing padding={{ blockend: 'two' }}>
                              <UitkText size={600} theme="default">
                                {card.heading}
                              </UitkText>
                            </UitkSpacing>
                            <UitkText size={300} theme="default">
                              {card.subHeading}
                            </UitkText>
                          </UitkLayoutFlex>
                        </div>
                        <div>
                          <UitkLayoutFlex space="two" wrap="wrap">
                            {card.buttons.map((button) => (
                              <UitkSpacing key={button.label}>
                                <UitkTertiaryButton href={button.href} alignLabelToContent="start">
                                  {button.label}
                                </UitkTertiaryButton>
                              </UitkSpacing>
                            ))}
                          </UitkLayoutFlex>
                        </div>
                      </UitkLayoutFlex>
                    </UitkCard>
                  </UitkLayoutGridItem>
                ))}
              </UitkLayoutGrid>
            </UitkLayoutFlexItem>
          </UitkLayoutFlex>
        </UitkSpacing>
      </section>
    </UitkLayoutFlexItem>
  );
};

export default SolutionCards;
